<template>
  <div>
    <b-form-group
      v-if="inputAdditions == 'mobile'"
      class="lato-regular field-headings"
      :label="labelName"
    >
      <b-input-group
        v-if="isdCode"
        :prepend="isdCode"
        class="width-control-small lato-regular-input"
      >
        <b-form-input
          :name="errorMessage"
          :id="labelName"
          :value="defaultValue"
          v-validate="validation"
          :state="errors.has(errorMessage) ? false : null"
          @keydown="inputMobileText($event)"
          @keyup="inputMobileText($event)"
          class="width-control-small lato-regular-input m-0"
          :disabled="disabled"
          :type="type"
          autocomplete="off"
        ></b-form-input>
      </b-input-group>
      <b-form-input
        v-else
        :name="errorMessage"
        :id="labelName"
        :value="defaultValue"
        v-validate="validation"
        :state="errors.has(errorMessage) ? false : null"
        @keydown="inputMobileText($event)"
        @keyup="inputMobileText($event)"
        class="width-control-small lato-regular-input m-0"
        :disabled="disabled"
        :type="type"
        autocomplete="off"
      ></b-form-input>
      <div
        :class="'helo-block alert alert-danger errorWidthSmall mt-1'"
        v-show="errors.has(errorMessage)"
      >{{errors.first(errorMessage)}}</div>
    </b-form-group>

    <b-form-group
      v-if="inputAdditions==null"
      class="lato-regular field-headings"
      :class="className"
      :label="labelName"
    >
      <b-form-input
        v-if="allowOnlyCharacters == null"
        :name="errorMessage"
        :value="defaultValue"
        :id="labelName"
        v-validate="validation"
        :state="errors.has(errorMessage) ? false : null"
        class="width-control-small lato-regular-input"
        @keydown="inputText($event)"
        @keyup="inputText($event)"
        :disabled="disabled"
        :type="type"
        autocomplete="off"
      ></b-form-input>

      <b-form-input
        v-if="allowOnlyCharacters == true"
        :name="errorMessage"
        :value="defaultValue"
        :id="labelName"
        v-validate="validation"
        :state="errors.has(errorMessage) ? false : null"
        class="width-control-small lato-regular-input"
        @keydown="inputTextAlphabets($event)"
        @keyup="inputTextAlphabets($event)"
        :disabled="disabled"
        :type="type"
        autocomplete="off"
      ></b-form-input>
      <div
        :class="'helo-block alert alert-danger errorWidthSmall mt-1'"
        v-show="errors.has(errorMessage)"
      >{{errors.first(errorMessage)}}</div>
    </b-form-group>
  </div>
</template>

<script>
export default {
  components: {},
  props: [
    "labelName",
    "validation",
    "inputAdditions",
    "isdCode",
    "className",
    "disabled",
    "defaultValue",
    "type",
    "maxDigits",
    "allowOnlyCharacters",
    "errorMessage",
    "maxCharacter"
  ],
  data() {
    return {
      inputValue: null,
      coordinationPersonName: null,
      inputAdditions: null
    };
  },
  computed: {},
  created() {
    this.inputValue = this.defaultValue;
    // console.log(this.className);
  },
  methods: {
    inputMobileText(event) {
      // alert(event.keyCode);
      if (this.maxDigits) {
        if (
          event.keyCode != 69 &&
          event.keyCode != 187 &&
          event.keyCode != 189 &&
          event.keyCode != 110 &&
          event.keyCode != 109 &&
          event.keyCode != 107 &&
          event.keyCode != 190
        ) {
          if (event.target.value) {
            if (event.target.value.length >= this.maxDigits) {
              this.$emit("textInputChange", event.target.value);
              if (
                event.keyCode == 46 ||
                event.keyCode == 8 ||
                event.keyCode == 37 ||
                event.keyCode == 39 ||
                event.keyCode == 9
              ) {
                this.$emit("textInputChange", event.target.value);
                return true;
              } else {
                event.preventDefault();
                return false;
              }
            } else {
              this.$emit("textInputChange", event.target.value);
              return true;
            }
          }
        } else {
          event.preventDefault();
          return false;
        }
      } else {
        this.$emit("textInputChange", event.target.value);
        return true;
      }
    },
    inputText(event) {
      console.log(event.keyCode);
      if (event.target.value.length <= this.maxCharacter) {
        if (this.type == "number") {
          if (
            event.keyCode == 189 ||
            event.keyCode == 187 ||
            //event.keyCode == 69 ||
            event.keyCode == 38 ||
            event.keyCode == 40
          ) {
            event.preventDefault();
          } else {
            this.$emit("textInputChange", event.target.value);
          }
        } else {
          this.$emit("textInputChange", event.target.value);
        }
      } else {
        if (event.keyCode == 8) {
          this.$emit("textInputChange", event.target.value);
          return true;
        }
        event.preventDefault();
        return false;
      }
    },
    inputTextAlphabets(event) {
      var key = event.keyCode;
      if (event.target.value.length <= this.maxCharacter) {
        if (
          (key >= 65 && key <= 90) ||
          event.keyCode == 46 ||
          event.keyCode == 8 ||
          event.keyCode == 37 ||
          event.keyCode == 39 ||
          event.keyCode == 32 ||
          event.keyCode == 9
        ) {
          this.$emit("textInputChange", event.target.value);
        } else {
          event.preventDefault();
        }
      } else {
        if (event.keyCode == 8) {
          this.$emit("textInputChange", event.target.value);
          return true;
        } else {
          event.preventDefault();
          return false;
        }
      }
    }
  }
};
</script>
<style scoped>
.errorWidth {
  font-size: 12px !important;
  width: 100% !important;
  padding: 2px !important;
}
.was-validated .form-control:invalid,
.form-control.is-invalid {
  background-image: none;
}
.bold {
  font-weight: bold !important;
}
</style>